module.exports = __webpack_public_path__ + "img/MagicShine.bd69e1a0.jpg";